import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { showErrors } from '@/utils/snack';
import { utcDateTimeToLocal } from '@/utils/dateTime';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppDatePicker from '@/components/AppDatePicker.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import AppTextarea from '@/components/AppTextarea.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppSimpleButton from '@/components/AppSimpleButton.vue';
import AppFormItem from '@/components/AppFormItem.vue';
import { findOrder } from '../OrderList/gql';
import { OrderStatusText } from '@/helpers/order';
import { formatCurrency } from '@/utils/currency';

var OrderDetail = /*#__PURE__*/function (_Vue) {
  _inherits(OrderDetail, _Vue);

  var _super = _createSuper(OrderDetail);

  function OrderDetail() {
    var _this;

    _classCallCheck(this, OrderDetail);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '订单管理'
    }, {
      text: '订单',
      to: {
        name: 'OrderList'
      }
    }];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.formatCurrency = formatCurrency;
    _this.OrderStatusText = OrderStatusText;
    _this.loading = false;
    _this.headers = [{
      text: '征订周期',
      value: 'period',
      sortable: false,
      width: 150
    }, {
      text: '标题',
      value: 'title',
      sortable: false
    }, {
      text: 'ISBN',
      value: 'isbn',
      sortable: false
    }, {
      text: '单价',
      value: 'price',
      sortable: false
    }, {
      text: '数量',
      value: 'count',
      sortable: false
    }];
    _this.options = {
      sortBy: ['count'],
      sortDesc: [true]
    };
    _this.goods = null;
    _this.order = null;
    _this.orderId = '';
    return _this;
  }

  _createClass(OrderDetail, [{
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.onResize();
                id = this.$route.params.id;
                this.orderId = id;
                _context.next = 5;
                return this.getOrderById();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "updateAddress",
    value: function () {
      var _updateAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {} catch (e) {
                  typedError = e;
                  showErrors(typedError.graphQLErrors);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function updateAddress() {
        return _updateAddress.apply(this, arguments);
      }

      return updateAddress;
    }()
  }, {
    key: "getOrderById",
    value: function () {
      var _getOrderById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var result, _this$order, typedError;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findOrder,
                  variables: {
                    orderId: +this.orderId
                  }
                });

              case 3:
                result = _context3.sent;

                if (result) {
                  this.order = result.data.findOrder;
                  this.breadcrumbs.push({
                    text: "".concat(result.data.findOrder.orderNumber)
                  });
                  this.goods = (_this$order = this.order) === null || _this$order === void 0 ? void 0 : _this$order.items;
                }

                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getOrderById() {
        return _getOrderById.apply(this, arguments);
      }

      return getOrderById;
    }()
  }, {
    key: "exportHandler",
    value: function exportHandler() {}
  }, {
    key: "editOrder",
    value: function editOrder(item, type) {
      this.$router.push({
        name: 'EditOrder',
        params: {
          type: type,
          id: item.id
        }
      });
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
    }
  }, {
    key: "buyer",
    get: function get() {
      var _this$order2;

      var address = (_this$order2 = this.order) === null || _this$order2 === void 0 ? void 0 : _this$order2.address;
      var area = address === null || address === void 0 ? void 0 : address.school.area.mergerName;
      var school = address.school,
          year = address.year,
          className = address.className,
          realname = address.realname,
          phone = address.phone;
      return area + '-' + school.name + '-' + year + '年入学-' + className + '-' + realname + '-' + (phone || '-');
    }
  }]);

  return OrderDetail;
}(Vue);

OrderDetail = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSimpleSelector: AppSimpleSelector,
    AppDatePicker: AppDatePicker,
    AppTextarea: AppTextarea,
    AppTextField: AppTextField,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppSimpleButton: AppSimpleButton,
    AppFormItem: AppFormItem
  }
})], OrderDetail);
export default OrderDetail;